import React, { useState } from "react";
import queries from "../helpers/queries";
import { withUser } from "../Contexts/user";
import { useQuery } from "@apollo/react-hooks";
const moment = require("moment");

const dateTo = moment(Date.now()).subtract(1, "day").format("YYYY-MM-DDTHH:mm:ss.SSSZ");
const dateFrom = moment(Date.now()).subtract(1, "day").format("YYYY-MM-DDTHH:mm:ss.SSSZ");

const SalesRankingPercentage = (user) => {
    const [rankingData, setRankingData] = useState([]);
    const [selectedFilter, setSelectedFilter] = useState("OVERALL");

    // Determine state name based on user's state
    let stateName = ""
    if (user.user.auth.state.name === "Kuala Lumpur") {
        stateName = "kl"
    } else if (user.user.auth.state.name === "Johor Bahru") {
        stateName = "jb"
    } else if (user.user.auth.state.name === "Melaka") {
        stateName = "melaka"
    } else if (user.user.auth.state.name === "Ipoh") {
        stateName = "ipoh"
    } else if (user.user.auth.state.name === "Penang") {
        stateName = "penang"
    }

    const { data: casesData } = useQuery(
        queries.FETCH_TOP_30,
        {
            fetchPolicy: "network-only",
            variables: {
                dateTo: dateTo,
                dateFrom: dateFrom,                             
                state: selectedFilter === "OVERALL" ? "all" : stateName,
                type: "sales"
            },
            onCompleted: () => {
                const originalData = casesData.fetchTop30s.data.top30;
                setRankingData(originalData);
            },
        }
    );

    const capitalizeWords = str => {
        return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    };

    const formatName = (member) => {
        if (!member) return "Unknown";
        const nickname = member.nickname && member.nickname !== "-" ? member.nickname : "";
        const name = member.name || "";
        return `${capitalizeWords(nickname)} ${capitalizeWords(name)}`.trim();
    };

    const renderTopThree = () => {
        const top3 = rankingData.slice(0, 3);
        return (
            <div className="top-circles">
                {/* Second Place */}
                <div className="ranking-circle">
                    <div className="circle-container circle-small">
                        <img 
                            src={top3[1]?.member?.image || "https://venti-fans.com/wp-content/uploads/2025/04/DD_SystemIcons-28.png"}
                            alt={top3[1]?.member ? formatName(top3[1].member) : "Second Place"}
                            className="circle-image"
                        />
                        <img 
                            src="https://venti-fans.com/wp-content/uploads/2025/04/DD_SystemIcons-29.png"
                            alt="Silver Medal"
                            className="ranking-medal"
                        />
                    </div>
                    <div className="ranking-name">{top3[1]?.member ? formatName(top3[1].member) : "N/A"}</div>
                    <div className="ranking-percentage">{top3[1]?.commission ? top3[1].commission.toFixed(2) : "0.00"}%</div>
                </div>

                {/* First Place */}
                <div className="ranking-circle">
                    <div className="circle-container circle-large">
                        <img 
                            src={top3[0]?.member?.image || "https://venti-fans.com/wp-content/uploads/2025/04/DD_SystemIcons-28.png"}
                            alt={top3[0]?.member ? formatName(top3[0].member) : "First Place"}
                            className="circle-image"
                        />
                        <img 
                            src="https://venti-fans.com/wp-content/uploads/2025/04/DD_SystemIcons-28.png"
                            alt="Gold Medal"
                            className="ranking-medal"
                        />
                    </div>
                    <div className="ranking-name">{top3[0]?.member ? formatName(top3[0].member) : "N/A"}</div>
                    <div className="ranking-percentage">{top3[0]?.commission ? top3[0].commission.toFixed(2) : "0.00"}%</div>
                </div>

                {/* Third Place */}
                <div className="ranking-circle">
                    <div className="circle-container circle-small">
                        <img 
                            src={top3[2]?.member?.image || "https://venti-fans.com/wp-content/uploads/2025/04/DD_SystemIcons-28.png"}
                            alt={top3[2]?.member ? formatName(top3[2].member) : "Third Place"}
                            className="circle-image"
                        />
                        <img 
                            src="https://venti-fans.com/wp-content/uploads/2025/04/DD_SystemIcons-30.png"
                            alt="Bronze Medal"
                            className="ranking-medal"
                        />
                    </div>
                    <div className="ranking-name">{top3[2]?.member ? formatName(top3[2].member) : "N/A"}</div>
                    <div className="ranking-percentage">{top3[2]?.commission ? top3[2].commission.toFixed(2) : "0.00"}%</div>
                </div>
            </div>
        );
    };

    const renderRankingList = () => {
        const remainingRankings = rankingData.slice(3);
        const rows = [];
        
        // Group items into rows of 4
        for (let i = 0; i < remainingRankings.length; i += 4) {
            const rowItems = remainingRankings.slice(i, i + 4);
            rows.push(rowItems);
        }

        return (
            <div className="ranking-list">
                {rows.map((row, rowIndex) => (
                    <div key={rowIndex} className="ranking-row">
                        {row.map((item, index) => (
                            <div key={index} className="ranking-item">
                                <span className="ranking-position">Top {4 + rowIndex * 4 + index}</span>
                                <span className="ranking-item-name">{formatName(item.member)}</span>
                                <span className="ranking-item-percentage">{item.commission.toFixed(2)}%</span>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div className="">
            <div className="flex flex-wrap rounded-2xl w-full overflow-hidden my-10 lg:my-0 lg:p-8">
                <div className="w-full ranking-card">
                    <div className="ranking-header">
                        <h1 className="ranking-title">TOP 30 PERCENTAGE</h1>
                        <select 
                            value={selectedFilter}
                            onChange={(e) => setSelectedFilter(e.target.value)}
                            className="ranking-filter"
                        >
                            <option value="OVERALL">OVERALL</option>
                            <option value="STATE">{user.user.auth.state.name.toUpperCase()}</option>
                        </select>
                    </div>
                    <div className="ranking-card-content">
                        <div className="ranking-container">
                            {renderTopThree()}
                            {renderRankingList()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withUser(SalesRankingPercentage);
